import { render, staticRenderFns } from "./shippingMethod.vue?vue&type=template&id=47c988b8&scoped=true"
import script from "./shippingMethod.vue?vue&type=script&lang=js"
export * from "./shippingMethod.vue?vue&type=script&lang=js"
import style0 from "./shippingMethod.vue?vue&type=style&index=0&id=47c988b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c988b8",
  null
  
)

export default component.exports